import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Model from 'flarum/common/Model';
export default class MundialScore extends Model {
  constructor() {
    super(...arguments);
    _defineProperty(this, "userId", Model.attribute('userId'));
    _defineProperty(this, "score", Model.attribute('score'));
    _defineProperty(this, "sameVoteCount", Model.attribute('sameVoteCount'));
    _defineProperty(this, "createdAt", Model.attribute('createdAt', Model.transformDate));
    _defineProperty(this, "updatedAt", Model.attribute('updatedAt', Model.transformDate));
    _defineProperty(this, "user", Model.hasOne('user'));
  }
}
flarum.reg.add('nagusi-match-ratings', 'common/models/MundialScore', MundialScore);